// Mutates the imported `environment` object in place, applying runtime
// overrides from window.APP_ENV (populated by /assets/env.js, which is
// stub-generated at build time and substituted at container start by
// docker/scripts/runtime-env.sh).
//
// Imported as a side effect from main.ts so the mutation lands before any
// other module-level reads of `environment` (e.g. graphql.module.ts:8's
// top-level `const uri = environment.apiUrl`). ES module bindings are live —
// every consumer of `./environment` sees the same object instance and
// therefore the mutated values.
//
// If window.APP_ENV is unavailable (running `ng serve` without a prior
// prebuild step, for example), the override map is empty and apply() is a
// no-op — compile-time values stand. Robust fallback.
import { environment } from './environment';

const overrides: Record<string, string> =
	(typeof window !== 'undefined' && (window as unknown as Record<string, unknown>).APP_ENV as Record<string, string>) || {};

const isPlainObject = (v: unknown): v is Record<string, unknown> =>
	typeof v === 'object' && v !== null && !Array.isArray(v) &&
	(v.constructor === Object || v.constructor === undefined);

const coerce = (override: string, base: unknown): unknown => {
	if (typeof base === 'boolean') {return override === 'true';}
	if (typeof base === 'number')  {return Number(override);}
	return override;
};

const apply = (target: Record<string, unknown>, prefix = ''): void => {
	for (const [k,
		v] of Object.entries(target)) {
		const flat = prefix ? `${prefix}_${k}` : k;
		if (isPlainObject(v)) {
			apply(v, flat);
		} else if (overrides[flat] !== undefined && overrides[flat] !== '') {
			target[k] = coerce(overrides[flat], v);
		}
	}
};

apply(environment as unknown as Record<string, unknown>);
